import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Menu, MenuList, MenuItem, ListItemText } from '@mui/material';
import { FileUploadOutlined } from '@mui/icons-material';
import { getActivity } from '@features/tickets/libs';

type Props<T, C> = {
  handleClickExport: () => void;
  handleClickExportEmail: () => void;
  columns: C[];
  tableData: T[];
  hiddenColumnNames: boolean[];
  active?: boolean;
};

export const ExportButton = <T, C>({
  handleClickExport,
  handleClickExportEmail,
  columns,
  tableData,
  hiddenColumnNames,
  active = false,
}: Props<T, C>) => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) =>
    setAnchorEl(event.currentTarget);

  const handleClose = () => setAnchorEl(null);

  const isActive =
    active === false ? getActivity({ columns, tableData, hiddenColumnNames }) : true;

  return (
    <>
      <Button
        variant="outlined"
        color="primary"
        onClick={handleClick}
        disabled={!isActive}
        startIcon={<FileUploadOutlined />}
      >
        {t('export')}
      </Button>
      <Menu open={open} anchorEl={anchorEl} onClose={handleClose}>
        <MenuList>
          <MenuItem onClick={handleClickExport}>
            <ListItemText>
              {`${t('UploadToExcel')} (1000 ${t('ofTickets')})`}
            </ListItemText>
          </MenuItem>
          <MenuItem onClick={handleClickExportEmail}>
            <ListItemText>{`${t('SendByEmail')} (40000 ${t('ofTickets')})`}</ListItemText>
          </MenuItem>
        </MenuList>
      </Menu>
    </>
  );
};
